/** Known Moonbug CMS ids — fallback when content-owners API is unavailable. */
export const KNOWN_CMS_DISPLAY_NAMES: Record<string, string> = {
  "2FgLC4rERnU_KMmQsEuxBw": "Moonbug Music",
  "7A8nsWSEMsFcVZBw1q94rg": "Moonbug",
  "7ONmHxhe_ykZR0inqLNFtg": "Little Angel",
  ANaGDAEYmPd4tsGtoDLKqg: "Blippi",
  GBkfkc5yQbFtC1qAed8o0w: "Morphle TV",
  z1eQnuuNNLYyyRQ1LB0HAQ: "One Animation",
  krJbnRgRWkwnG_uKWxufXg: "Fun Learning Studios Ltd",
  "xETA4Lt2BhAiuJGxp4tr-A": "Little Baby Bum",
  kEc4TsN5czYZiZh7ONTH2g: "Supa Strika",
};

export function mergeCmsDisplayNames(
  contentOwners: Array<{ id: string; displayName: string }>
): Record<string, string> {
  const map = { ...KNOWN_CMS_DISPLAY_NAMES };
  for (const owner of contentOwners) {
    const id = owner.id?.trim();
    if (!id) {
      continue;
    }
    map[id] = owner.displayName?.trim() || id;
  }
  return map;
}

export function cmsDisplayName(
  cmsId: string | undefined,
  nameById: Record<string, string>
): string {
  const normalized = cmsId?.trim();
  if (!normalized) {
    return "N/A";
  }
  return nameById[normalized] ?? normalized;
}

export function buildCmsFilterOptions(
  cmsIds: string[],
  nameById: Record<string, string>
): { label: string; value: string }[] {
  return Array.from(new Set(cmsIds.map((id) => id.trim()).filter(Boolean)))
    .map((id) => ({
      label: cmsDisplayName(id, nameById),
      value: id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
